/*
 * Copyright (c) 2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */

import App from 'apmui/App';
import EventTags from 'apmui/EventTags';
import ResourceModel from 'apmui/resource/Model';
import IPageModel from 'apmui/page';
import PageType from 'apmui/page/PageType';
import RESOURCE from 'apmui/resource/ResourceType';

const app = App.get();

function launchFolder(resource: ResourceModel, page: IPageModel) {
    if (page.pageType !== PageType.WEBTOP) {
        return;
    }
    page.webtop.activeFolder = resource.id;
}

app.subscribe(EventTags.RESOURCE_CLOSED, ({ detail }, page) => {
    if (page.pageType === PageType.WEBTOP && detail.type === RESOURCE.WEBTOP_FOLDER) {
        page.webtop.activeFolder = undefined;
    }
});

export default launchFolder;
